import { css } from "@emotion/react";

export const notificationBannerContainer = (theme, variant) => {
  const variants = {
    danger: theme.notificationBanner.danger,
    warning: theme.notificationBanner.warning,
  };

  const { background = "", color = "" } = variants[variant] || {};

  return css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline: 2rem;
    width: 100%;
    height: 2.5rem;
    background: ${background};
    color: ${color};

    .notification-banner {
      &-title,
      &-description,
      &-actions {
        flex: 1;
      }

      &-title,
      &-actions {
        max-width: 15rem;
      }

      &-description {
        text-align: center;
      }
      &-actions {
        text-align: right;
        .btn-text {
          color: ${color};
        }
      }
    }
  `;
};
